<!-- src/components/Toast.vue -->
<template>
  <transition name="fade">
    <div class="toast-container" v-show="visible">
      <div :class="['toast', type]">
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalToast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'success', // 'success' | 'error'
      timer: null
    }
  },
  methods: {
    show(message, type = 'success', duration = 2000) {
      this.message = message
      this.type = type
      this.visible = true

      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.visible = false
      }, duration)
    }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none;
}

.toast {
  padding: 12px 24px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  max-width: 80%;
  word-break: break-word;
}

.toast.success {
  background-color: #67c23a; /* Element UI 的 success 绿 */
}

.toast.error {
  background-color: #f56c6c; /* Element UI 的 error 红 */
}

/* 淡入淡出动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
